import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { UserStore } from '@/store/user-module';
import { stTimeEntryDayApprovalApi } from '@/services/st-api';
import { TeamOverviewApprovalModel } from '@/services/api/nswag/stapiclient_generated';
import { DateTime } from 'luxon';

@Module({ dynamic: true, store, name: 'ApprovalModule', namespaced: true })
export default class ApprovalModule extends VuexModule {
  public openApprovalRequestCount: number = 0;
  model: TeamOverviewApprovalModel = TeamOverviewApprovalModel.fromJS({});
  date: DateTime = UserStore.userNowDateTime;

  @Mutation
  setModel(data: TeamOverviewApprovalModel) {
    this.model = data;
  }

  @Mutation
  setDate(data: DateTime) {
    this.date = data;
  }

  @Mutation
  setOpenApprovalRequestCount(data: number) {
    this.openApprovalRequestCount = data;
  }

  @Action
  async getModel() {
    this.setModel(await stTimeEntryDayApprovalApi.getTeamOverviewApprovalModel(this.date.toFormat('yyyy-MM-dd')));
  }

  @Action
  async getOpenApprovalRequestCount() {
    if (UserStore.userSettings.featureFlagTimeApproval && UserStore.userSettings.CanApproveTimeEntryDays) {
      let result = await stTimeEntryDayApprovalApi.getNoOfOpenApprovals();
      this.setOpenApprovalRequestCount(result);
    }
  }
}

export const ApprovalStore = getModule(ApprovalModule);
